import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import theme from './styles/CustomTheme';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/he';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from 'dayjs/plugin/weekday';
import { UserContextProvider } from './contexts/UserContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Import the i18n configuration file
import { Provider } from 'react-redux'; // Redux
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store'; // Redux store

// Configure dayjs to start week on Sunday for both English and Hebrew
dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.updateLocale('en', {
  weekStart: 0, // Sunday = 0
});
dayjs.updateLocale('he', {
  weekStart: 0, // Sunday = 0 for Hebrew as well
});
dayjs.updateLocale('he', {
  weekStart: 0, // Sunday = 0 for Hebrew as well
});

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

// Create separate LTR cache for date pickers
const cacheLtr = createCache({
  key: 'muiltr',
  stylisPlugins: [prefixer],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en"
            dateFormats={{ date: 'DD/MM/YYYY' }}
            localeText={{ start: 'Start', end: 'End' }}
          >
            <UserContextProvider>
              <I18nextProvider i18n={i18n}>
                <App />
              </I18nextProvider>
            </UserContextProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </CacheProvider>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
